import { setContext } from '@apollo/client/link/context';
import addAuthHeader from '~/contexts/Auth/util/addAuthHeader';

import apolloClient from './client';
import monolithMetadataClient from '~/monolith/monolithApolloClient';
import analyticsClient from '~/analytics/util/analyticsApolloClient';

const setGraphAuthHeader = (token: string) => {
  [apolloClient, monolithMetadataClient, analyticsClient].forEach((client) => {
    const contextLink = setContext((_, { headers }) => ({
      headers: addAuthHeader(headers, token),
    }));

    client.setLink(contextLink.concat(client.link));
  });
};

export default setGraphAuthHeader;
